export const PROMPT_EDITOR_DATA_REQUEST = "PROMPT_EDITOR_DATA_REQUEST";
export const PROMPT_EDITOR_DATA = "PROMPT_EDITOR_DATA";
